const brandTheme = {
    mainColor:'#d3d3d3',
    errorColor:'#f44336',
    buttonColor: '#2f2f2fc9',
    buttonHoverColor:'#2f2f2f',
    white:'#ffffff',
    black: '#2f2f2f',
    fieldColor: '#bdbdbd',
    footerBackGroundColor:'#d3d3d33b',
    headerBackGroundColor:'#d3d3d33b',
    sideBarColor: '#d3d3d33b',
    sideBarHoverColor: "#d3d3d3",
    headerFontSize: "1.75rem",
    headerFontSizeMobile: "1.35rem",
    textFontSize: "0.85rem",
    button2Color: "#848181",
    disabled:"#e5e5e5",
    green: "#258D40",
    tableBackgroundColor:"#9C9C9A",
    labelColor:"#999999",
    tableHeaderColor:"#fafafa",
    tableHoverColor:"#0000000a",
    dashboardSliderColor:"#fad160",
    font: {
        roboto: 'Roboto',
        poppins: 'Poppins',
        // hindFontSemiBold: 'Hind-SemiBold',
        // hindFontRegular: 'Hind-Regular',
        // hindFontMedium: 'Hind-Medium',
        // hindFontLight: 'Hind-Light',
        // bebaseNeueRegular: 'BebasNeue-Regular'
    },
    
};

export default brandTheme;
